var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 40 26","preserveAspectRatio":"none"}},[_c('path',{attrs:{"d":"M.136 10.834h30.702l-7.757-7.778L26.136.001l13 13-13 13-3.055-3.055 7.757-7.778H.136z","fill-rule":"evenodd"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }